var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultInfoAvatarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 380,
    fill: "#D7D7DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22603_215394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.459 190.154C216.038 190.154 235.286 170.906 235.286 147.327C235.286 123.748 216.038 104.5 192.459 104.5C168.88 104.5 149.632 123.748 149.632 147.327C149.632 170.906 168.88 190.154 192.459 190.154ZM189.356 177.144C190.374 177.241 191.409 177.305 192.459 177.305C191.409 177.305 190.374 177.257 189.356 177.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.934 222.217C260.352 219.308 259.269 216.496 257.41 214.201C254.776 210.936 250.784 209.013 246.696 208.076C242.607 207.139 238.373 207.155 234.187 207.155C206.018 207.155 177.833 207.187 149.665 207.203C142.522 207.203 134.683 207.462 129.366 212.229C125.488 215.72 123.726 221.086 123.516 226.306C123.322 231.655 124.534 237.101 125.633 242.273C126.053 244.293 127.589 246.475 128.655 248.22C129.819 250.111 131.144 251.905 132.566 253.602C138.126 260.195 145.398 265.254 153.285 268.664C165.422 273.9 178.835 275.435 192.055 275.5C208.216 275.581 224.927 273.367 238.761 265.011C252.594 256.656 262.921 241.061 261.338 224.98C261.241 224.059 261.111 223.138 260.934 222.217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22603_215394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.999,
    height: 171,
    fill: "white",
    transform: "translate(123.5 104.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultInfoAvatarUser);
export default __webpack_public_path__ + "static/media/default_info_avatar_user.a888771ac2f5fb69c7ec9cb5f647adf3.svg";
export { ForwardRef as ReactComponent };